<div class="modal__content modal__content-center">
    <div class="form__group">
        <p class="text" v-html="$t('modals.close.desc')"></p>
    </div>
    <button class="btn btn-orange btn-full" @click="end()" :disable="isSubmitting">{{ $t('modals.close.sessionEnd') }}</button>
    <button class="btn btn-black btn-full" @click="cancel()">{{ $t('modals.close.cancel') }}</button>
</div>